var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1145(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.254,
    height: 53.254,
    viewBox: "0 0 53.254 53.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_921",
    "data-name": "Rectangle 921",
    width: 53.254,
    height: 53.254,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_922",
    "data-name": "Rectangle 922",
    width: 15.682,
    height: 14.703,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 15.489,
    height: 14.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 25.252,
    height: 8.934,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(0 0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30188",
    "data-name": "Path 30188",
    d: "M508.743,30.2A26.627,26.627,0,1,1,482.117,3.575,26.627,26.627,0,0,1,508.743,30.2",
    transform: "translate(-455.489 -3.575)",
    fill: "#fac50c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(8.933 14.073)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30189",
    "data-name": "Path 30189",
    d: "M479.5,39.193c-1.714-.741-3.417-1.471-5.114-2.215a17.941,17.941,0,0,1-3.117-1.681,5.678,5.678,0,0,1-1.889-2.008,4.586,4.586,0,0,1-.223-4.127A3.67,3.67,0,0,1,471.818,27a3.742,3.742,0,0,1,3.02.678,2.519,2.519,0,0,1,.393.3c.556.559,1.2.332,1.351-.433a4.072,4.072,0,0,1,.776-1.629,3.732,3.732,0,0,1,4.179-1.211,4.328,4.328,0,0,1,2.52,2.486,5.259,5.259,0,0,1,0,3.97,18.34,18.34,0,0,1-1.711,3.418c-.921,1.512-1.858,3.014-2.788,4.521-.015.024-.033.047-.063.091",
    transform: "translate(-468.766 -24.49)",
    fill: "#e60e1b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "translate(28.709 13.827)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30190",
    "data-name": "Path 30190",
    d: "M502.2,38.853c-.832-1.672-1.663-3.328-2.481-4.99a17.978,17.978,0,0,1-1.3-3.294,5.675,5.675,0,0,1-.149-2.753,4.582,4.582,0,0,1,2.489-3.3,3.67,3.67,0,0,1,3.427.065,3.742,3.742,0,0,1,1.872,2.465,2.485,2.485,0,0,1,.108.481c.065.785.7,1.025,1.311.54a4.07,4.07,0,0,1,1.644-.745,3.732,3.732,0,0,1,3.976,1.768,4.331,4.331,0,0,1,.324,3.525,5.26,5.26,0,0,1-2.557,3.037,18.331,18.331,0,0,1-3.512,1.511c-1.679.562-3.364,1.107-5.046,1.659-.028.009-.055.015-.106.03",
    transform: "translate(-498.158 -24.125)",
    fill: "#e60e1b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(14.087 36.076)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30194",
    "data-name": "Path 30194",
    d: "M476.426,57.192c5.116,11.094,18.65,12.7,25.252,0Z",
    transform: "translate(-476.426 -57.192)",
    fill: "#826a20"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1145);
export default __webpack_public_path__ + "static/media/Group 1145.ffc316d375434dd53b78e7be91598ef6.svg";
export { ForwardRef as ReactComponent };